import { FormsHandbookModel as Model } from './Model'


export const MODULE_NAME = 'handbook_routes'
export const MODULE_NAME_CACHES = 'handbooks-cache'

export const FORMS_HANDBOOK_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
} as const

export const MENU = {
  id: FORMS_HANDBOOK_ROUTES.LAYOUT,
  route: { name: FORMS_HANDBOOK_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-book-open-variant',
} as const
